import { getScrollEventTarget, scrollContainerMediaQuery } from '@theme/scroll-container';

const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

const stageForLanding = (header, hero) => {
  const headerBottom = header.getBoundingClientRect().bottom;
  const headerHeight = header.getBoundingClientRect().height;
  const heroBottom = hero.getBoundingClientRect().bottom;
  const transitionWindow = Math.max(28, Math.round(headerHeight * 0.7));

  if (heroBottom > headerBottom + transitionWindow) return 'hero';
  if (heroBottom > headerBottom + 8) return 'transition';
  return 'header';
};

const logoHandoffProgress = (header, mark) => {
  const headerRect = header.getBoundingClientRect();
  const markBottom = mark.getBoundingClientRect().bottom;

  if (reducedMotionMediaQuery.matches) return markBottom <= headerRect.bottom ? 1 : 0;

  const fadeDistance = Math.max(32, Math.min(48, Math.round(headerRect.height * 0.65)));
  return Math.min(1, Math.max(0, (headerRect.bottom + fadeDistance - markBottom) / fadeDistance));
};

const setInteractiveLogo = (element, isInteractive) => {
  element.toggleAttribute('inert', !isInteractive);
  element.setAttribute('aria-hidden', String(!isInteractive));
};

const initializeLanding = (landing) => {
  if (landing.dataset.bislboxLandingInitialized === 'true') return;

  const header = document.querySelector('header-component');
  const hero = landing.querySelector('[data-bislbox-storefront-hero]');
  const heroLogo = landing.querySelector('.bislbox-brand-hero__mark-link');
  const headerLogo = header?.querySelector('.header-logo');

  if (!header || !hero || !heroLogo || !headerLogo) return;

  landing.dataset.bislboxLandingInitialized = 'true';

  let frame = null;
  let scrollEventTarget = null;

  const updateStage = () => {
    frame = null;
    landing.dataset.scrollStage = stageForLanding(header, hero);

    const progress = logoHandoffProgress(header, heroLogo);
    const focusHeaderLogo = progress >= 0.5;

    landing.style.setProperty('--bislbox-logo-handoff-progress', progress.toFixed(4));
    headerLogo.style.setProperty('--bislbox-logo-handoff-progress', progress.toFixed(4));
    landing.dataset.logoHandoff = progress === 0 ? 'hero' : progress === 1 ? 'header' : 'transition';
    landing.dataset.logoFocus = focusHeaderLogo ? 'header' : 'hero';
    setInteractiveLogo(heroLogo, !focusHeaderLogo);
    setInteractiveLogo(headerLogo, focusHeaderLogo);
  };

  const requestStageUpdate = () => {
    if (frame !== null) return;
    frame = window.requestAnimationFrame(updateStage);
  };

  const bindScrollTarget = () => {
    scrollEventTarget?.removeEventListener('scroll', requestStageUpdate);
    scrollEventTarget = getScrollEventTarget();
    scrollEventTarget.addEventListener('scroll', requestStageUpdate, { passive: true });
    requestStageUpdate();
  };

  bindScrollTarget();
  window.addEventListener('resize', requestStageUpdate);
  scrollContainerMediaQuery.addEventListener('change', bindScrollTarget);
  reducedMotionMediaQuery.addEventListener('change', requestStageUpdate);
};

const initialize = () => {
  document.querySelectorAll('[data-bislbox-storefront-landing]').forEach(initializeLanding);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initialize, { once: true });
} else {
  initialize();
}

document.addEventListener('shopify:section:load', initialize);
